import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type HotelSettingsCompetitorsBenchmarkCompsetRoute from 'lumen/routes/hotel/settings/competitors/benchmark/compset';
import type { Transition } from 'lumen/services/transition';
import { ROUTE_BENCHMARK_INSIGHT_COMPSET_BUILDER } from 'lumen/utils/constants/benchmark-insight/beni-constant-values';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCompetitorsBenchmarkCompsetBuilderRoute extends Route {
  @service declare access: Services['access'];
  @service('benchmark-insight/competitors/compset')
  declare benchmarkInsightCompetitorsCompset: Services['benchmark-insight/competitors/compset'];
  @service('benchmark-insight/competitors/desired-compset')
  declare benchmarkInsightCompetitorsDesiredCompset: Services['benchmark-insight/competitors/desired-compset'];
  @service declare router: Services['router'];

  beforeModel(transition: Transition): void {
    if (!this.access.hasBenchmarkInsightSettingsCompsetEdit) {
      this.router.transitionTo('hotel.settings.competitors.benchmark.compset');
    }

    if (transition.to?.name === ROUTE_BENCHMARK_INSIGHT_COMPSET_BUILDER) {
      this.router.transitionTo(
        'hotel.settings.competitors.benchmark.compset.builder.desired-compset',
      );
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model() {
    const parentModel = this.modelFor(
      'hotel.settings.competitors.benchmark.compset',
    ) as ModelFrom<HotelSettingsCompetitorsBenchmarkCompsetRoute>;

    const model = {
      compset: parentModel.compset,
      desiredCompset:
        this.benchmarkInsightCompetitorsDesiredCompset.desiredCompsetTask,
      proposedCompsets:
        this.benchmarkInsightCompetitorsCompset.getProposedCompsetsTask,
    };

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    model.desiredCompset.perform();

    return model;
  }
}
